import moment from 'moment';
import React, { Component } from 'react';
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = (num = "") => {
    const separador = ','; // separador para los miles
    const sepDecimal = '.'; // separador para los decimales

    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
    let regex = /(\d+)(\d{3})/;

    while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
    return splitLeft + splitRight;
};

const finalDocStyles = {
    fontSize: { fontSize: 12 },
    colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

const previewStyles = {
    colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
}

class AccountStatus extends Component {
    render() {
        const { DocsToPrint, ReportsModel, finalDoc } = this.props;
        const styles = finalDoc ? finalDocStyles : previewStyles;

        const header = DocsToPrint[0].header;
        const lines = DocsToPrint[0].lines;

        let total = 0.0;
        let taxTotal = 0.0;

        return (
            <div className="p-4">
                <div style={styles.fontSize}>
                    <img style={{height:'5vh'}}  src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                    {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
                </div>
                <div style={styles.fontSize} className="text-center mt-3">
                    <p className="font-weight-bold h5"> Estado de cuenta </p>
                </div>

                <div style={styles.fontSize}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <p className="m-0"><strong>No. Referencia:</strong> {header.CardCode}</p>
                                    <p className="m-0">{header.CardName}</p>
                                    <p className="m-0">{header.Address}</p>
                                </td>
                                <td style={{ width: '60%', textAlign: 'right' }}>
                                    <p>{ReportsModel?.user?.Branch?.Address || `${Datos_Empresa.Calle} No. ${Datos_Empresa.Numero}, COL. ${Datos_Empresa.Colonia}, ${Datos_Empresa.Ciudad}, ${Datos_Empresa.Estado}. ${Datos_Empresa.Pais}`} al {moment().format("DD/MM/YYYY")}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div style={styles.fontSize}>
                    <p>Estimado;</p>
                    <p className="m-0">Por medio del presente le hacemos llegar el detalle de sus movimientos. Lo invitamos a que pase a pagar lo vencido y mantener su línea de crédito al día.</p>
                </div>

                <div style={styles.fontSize} className="mt-4">
                    <table className="border border-dark" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th style={styles.colNormal}>Fecha de creación</th>
                                <th style={styles.colNormal}>Concepto</th>
                                <th style={styles.colNumber}>Días vencido</th>
                                <th style={styles.colNumber}>Importe factura</th>
                                <th style={styles.colNumber}>Abono factura</th>
                                <th style={styles.colNumber}>Saldo factura</th>
                                <th style={styles.colNumber}>Interés</th>
                                <th style={styles.colNumber}>Importe vencido</th>
                            </tr>
                        </thead>
                        <tbody>
                            {lines.map((line) => {
                                total += Number(line.DueTotal || 0);
                                taxTotal += Number(line.Taxes || 0);
                                return (
                                    <tr key={line.DocNum}>
                                        <td style={styles.colNormal}>{moment(line.DocDate).format("DD/MM/YYYY")}</td>
                                        <td style={styles.colNormal}>{line.DocNum}</td>
                                        <td style={styles.colNumber}>{line.DueDays}</td>
                                        <td style={styles.colNumber}>{formatNumber(Number(line.DocTotal).toFixed(2))}</td>
                                        <td style={styles.colNumber}>{formatNumber(Number(line.Payment).toFixed(2))}</td>
                                        <td style={styles.colNumber}>{formatNumber(Number(line.Amount).toFixed(2))}</td>
                                        <td style={styles.colNumber}>{formatNumber(Number(line.Taxes).toFixed(2))}</td>
                                        <td style={styles.colNumber}>{formatNumber(Number(line.DueTotal).toFixed(2))}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="7" style={styles.colNormal}>Saldo vencido:</td>
                                <td style={styles.colNumber}>{formatNumber(total.toFixed(2))}</td>
                            </tr>
                            <tr>
                                <td colSpan="7" style={styles.colNormal}>Intereses moratorios:</td>
                                <td style={styles.colNumber}>{formatNumber(taxTotal.toFixed(2))}</td>
                            </tr>
                            <tr>
                                <td colSpan="7" style={styles.colNormal}>Saldos + intereses vencidos:</td>
                                <td style={styles.colNumber}>{formatNumber((total + taxTotal).toFixed(2))}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div style={styles.fontSize} className="mt-3">
                    <p className="m-0">Nota:</p>
                    <p className="m-0">* En caso de ya haber realizado su pago haga caso omiso a este aviso.</p>
                    <p className="m-0">* Si usted encuentra diferencias o tiene alguna queja favor de comunicarse al 01 800 52 38 499.</p>
                    <p className="m-0">Sin más nos despedimos agradeciendo de antemano su atención.</p>
                </div>
            </div>
        );
    }
}

export default AccountStatus;


//  last version 
// import moment from 'moment';
// import React, { Component } from 'react'
// import { Datos_Empresa, development } from "../../../libs/utils/Const";

// const formatNumber = (num = "") => {
//     const separador = ','; // separador para los miles
//     const sepDecimal = '.'; // separador para los decimales

//     let splitStr = num.split('.');
//     let splitLeft = splitStr[0];
//     let splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : '';
//     let regex = /(\d+)(\d{3})/;

//     while (regex.test(splitLeft)) { splitLeft = splitLeft.replace(regex, "$1" + separador + "$2"); }
//     return splitLeft + splitRight;
// };

// const finalDocStyles = {
//     fontSize: { fontSize: 12 },

//     colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//     colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
// }

// const previewStyles = {
//     colNormal: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
//     colNumber: { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "right" },
// }

// class AccountStatus extends Component {
//     render() {
//         const { DocsToPrint, ReportsModel, finalDoc } = this.props;
//         const styles = finalDoc ? finalDocStyles : previewStyles;

//         const header = DocsToPrint[0].header;
//         const lines = DocsToPrint[0].lines;

//         let total = 0.0;
//         let taxTotal = 0.0;

//         return (
//             <div className="p-4">
//                 <div className="row text-center">
//                     <div className="col-3 align-content-center" style={styles.fontSize}>
//                         <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
//                         {Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}
//                     </div>
//                     <div className="col-6 align-content-center">
//                         <p className="font-weight-bold h5"> Estado de cuenta </p>
//                     </div>
//                     <div className="col-3" />
//                 </div>
                
//                 <div className="row mt-3">
//                     <div className="col-5" style={styles.fontSize}>
//                         <p className="m-0"> <strong> No. Referencia: </strong> {header.CardCode} </p>
//                         <p className="m-0"> {header.CardName} </p> <br />
//                         <p className="m-0"> {header.Address} </p>
//                     </div>
//                     <div className="col-7 text-right">
//                         <p> {ReportsModel?.user?.Branch?.Address || `${Datos_Empresa.Calle} No. ${Datos_Empresa.Numero}, COL. ${Datos_Empresa.Colonia}, ${Datos_Empresa.Ciudad}, ${Datos_Empresa.Estado}. ${Datos_Empresa.Pais}`} al {moment().format("DD/MM/YYYY")}</p>
//                     </div>
//                 </div>
                
//                 <div className="row mt-3">
//                     <div className="col-12" style={styles.fontSize}>
//                         <p> Estimado; </p>
//                         <p className="m-0"> Por medio del presente le hacemos llegar el detalle de sus movimientos. Lo invitamos a que pase a pagar lo vencido y mantener su línea de crédito al día. </p>
//                     </div>
//                 </div>
                
//                 <div className="mt-4" style={styles.fontSize}>
//                     <div className="border border-dark font-weight-bold">
//                         <div className="row pl-3 pr-3">
//                             <div className="col-3">
//                                 <div className="row">
//                                     <div className="col-6" style={styles.colNormal}> Fecha de creación </div>
//                                     <div className="col-6" style={styles.colNormal}> Concepto </div>
//                                 </div>
//                             </div>

//                             <div className="col-6">
//                                 <div className="row">
//                                     <div className="col-3" style={styles.colNumber}> Dias vencido </div>
//                                     <div className="col-3" style={styles.colNumber}> Importe factura </div>
//                                     <div className="col-3" style={styles.colNumber}> Abono factura </div>
//                                     <div className="col-3" style={styles.colNumber}> Saldo factura </div>
//                                 </div>
//                             </div>

//                             <div className="col-3">
//                                 <div className="row">
//                                     <div className="col-6" style={styles.colNumber}> Interés </div>
//                                     <div className="col-6" style={styles.colNumber}> Importe vencido </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="border border-dark">
//                         {lines.map((line) => {
//                             total += Number(line.DueTotal || 0);
//                             taxTotal += Number(line.Taxes || 0);
//                             return (
//                                 <div className="row pl-3 pr-3">
//                                     <div className="col-3">
//                                         <div className="row">
//                                             <div className="col-6" style={styles.colNormal}> {moment(line.DocDate).format("DD/MM/YYYY")} </div>
//                                             <div className="col-6" style={styles.colNormal}> {line.DocNum} </div>
//                                         </div>
//                                     </div>
//                                     <div className="col-6">
//                                         <div className="row">
//                                             <div className="col-3" style={styles.colNumber}> {line.DueDays} </div>
//                                             <div className="col-3" style={styles.colNumber}> { formatNumber(Number(line.DocTotal).toFixed(2)) } </div>
//                                             <div className="col-3" style={styles.colNumber}> { formatNumber(Number(line.Payment).toFixed(2)) } </div>
//                                             <div className="col-3" style={styles.colNumber}> { formatNumber(Number(line.Amount).toFixed(2)) } </div>
//                                         </div>
//                                     </div>

//                                     <div className="col-3">
//                                         <div className="row">
//                                             <div className="col-6" style={styles.colNumber}> { formatNumber(Number(line.Taxes).toFixed(2)) } </div>
//                                             <div className="col-6" style={styles.colNumber}> { formatNumber(Number(line.DueTotal).toFixed(2)) } </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )
//                         })}
//                     </div>

//                     <div>
//                         <div className="row pl-3 pr-3">
//                             <div className="col-6" />
//                             <div className="col-6">
//                                 <div className="row">
//                                     <div className="col-9" style={styles.colNumber}> Saldo vencido: </div>
//                                     <div className="col-3 font-weight-bold" style={styles.colNumber}> { formatNumber(total.toFixed(2)) } </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div>
//                         <div className="row pl-3 pr-3">
//                             <div className="col-6" />
//                             <div className="col-6">
//                                 <div className="row">
//                                     <div className="col-9" style={styles.colNumber}> Intereses moratorios: </div>
//                                     <div className="col-3 font-weight-bold" style={styles.colNumber}> { formatNumber(taxTotal.toFixed(2)) } </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div>
//                         <div className="row pl-3 pr-3">
//                             <div className="col-6" />
//                             <div className="col-6">
//                                 <div className="row">
//                                     <div className="col-9" style={styles.colNumber}> Saldos + intereses vencidos: </div>
//                                     <div className="col-3 font-weight-bold" style={styles.colNumber}> { formatNumber((total + taxTotal).toFixed(2)) } </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
                
//                 <div className="row mt-3 font-weight-bold">
//                     <div className="col-12" style={styles.fontSize}>
//                         <p className="m-0"> Nota: </p>
//                         <p className="m-0"> * En caso de ya haber realizado su pago haga caso omiso a este aviso. </p>
//                         <p className="m-0"> * Si usted encuentra diferencias o tiene alguna queja favor de comunicarse al 01 800 52 38 499. </p> <br />
//                         <p className="m-0"> Sin más nos despedimos agradeciendo de antemano su atención. </p>
//                     </div>
//                 </div>
//             </div>
//         )
//     }
// }

// export default AccountStatus